import { useMutation } from "@tanstack/react-query";

import { createExtractionPoint } from "@services/extractionPoints";

export const useCreateExtractionPoint = (options: any = {}) => {
  return useMutation(createExtractionPoint, options);
};
